"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgHomeFilled = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9.78 19.92v-5.405h4.322v5.404c0 .595.486 1.081 1.08 1.081h3.243c.595 0 1.08-.486 1.08-1.08v-7.566h1.838c.497 0 .735-.616.357-.94l-9.035-8.138a1.09 1.09 0 00-1.448 0L2.18 11.414a.538.538 0 00.357.94h1.837v7.565c0 .595.487 1.081 1.081 1.081h3.242c.595 0 1.081-.486 1.081-1.08z" }) }))); };
exports.default = SvgHomeFilled;
